import React from 'react'
import { KeyBindProvider } from 'react-keybinds'
import { AppAside, AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index'
import { toggleStrapiEventEmitter } from '../i18n-backend'

const DefaultLayout = () => {
  const GLOBAL_COMMANDS = [
    {
      keys: {
        Mac: ['Control', 'Shift', 'S'],
        Windows: ['Control', 'Shift', 'S'],
      },
      label: 'show strapi translation keys',
      callback: () => {
        toggleStrapiEventEmitter.emit('toggle-strapi')
      },
    },
  ]

  return (
    <>
      <KeyBindProvider shortcuts={GLOBAL_COMMANDS}>
        <AppSidebar />
        <section className='wrapper'>
          <AppHeader />
          <AppContent />
          {/* <AppFooter /> */}
        </section>
        {/* <AppAside /> */}
      </KeyBindProvider>
    </>
  )
}

export default DefaultLayout
